import { useMemo } from 'react';
import { buildLinkUrl } from '../links/Link';
import { useFilterState } from '../../stores/FilterStateStore';
import { usePageState } from '../../stores/PageStateStore';
import { DrillInLink } from '../links/DrillInLink';

function HeaderLink(props) {
    const { column } = props;
    const [filterState] = useFilterState();
    const [pageState] = usePageState();
    const targetUrl = useMemo(
        () => buildLinkUrl(column.headerLink, column.headerLinkData, filterState, pageState),
        [column, filterState, pageState]
    );

    return <DrillInLink to={targetUrl}>{column.title}</DrillInLink>;
}

export function headerLinkRenderer(column) {
    return <HeaderLink column={column} />;
}
